import produce from "immer"
import { ACTIVE, ASC } from "const"
import { MtUser } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initUser: MtUser = {
    id: null,
    firstName: "",
    lastName: "",
    login: "",
    email: "",
    logoId: null,
    status: ACTIVE,
}

const initUserState: types.UserState = {
    userList: {},
    userIds: [],
    userView: initUser,
    userEdit: initUser,

    onlineUsers: {},

    sortColumn: "firstName",
    sortOrder: ASC,
    filters: {
        status: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const userReducer = produce((
    draft: types.UserState = initUserState,
    action: ActionTypes = null,
): types.UserState => {
    switch (action.type) {
        case types.USER_LIST:
            draft.userList = action.userList
            return draft

        case types.USER_IDS:
            draft.userIds = action.userIds
            return draft

        case types.USER_VIEW:
            draft.userView = action.user
            return draft

        case types.USER_EDIT:
            draft.userEdit = action.user
            return draft

        case types.ONLINE_USERS:
            draft.onlineUsers = action.onlineUsers
            return draft

        case types.USER_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.USER_FILTERS:
            draft.filters = action.filters
            return draft

        case types.USER_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.USER_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.USER_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default userReducer
